module.exports = "/_next/static/images/86b18e2e025fc1a00e590946089f775e-card-background-right-lg.jpg.webp";